import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { SpeedBumpImage, Wrapper } from './SpeedBumpTile.styles'

const SpeedBumpTile: React.FC<{ image: string }> = ({ image }) => {
  const defaultProperties = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)

  return (
    <Wrapper data-testid="speedbump">
      <SpeedBumpImage baseUrl={baseUrl} image={image} />
    </Wrapper>
  )
}

export default SpeedBumpTile
